import { ErrorRetry } from "../../common/ErrorRetry";
import { TopAgentsChart } from "./TopAgentsChart";
import { ProductMixChart } from "./ProductMixChart";

export function ReportSummaryInsightsSection({
  revenueAgentsState,
  revenueAgents,
  categoryState,
  categoryData,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {revenueAgentsState.loading ? (
        <TopAgentsChart topRevenueAgents={[]} loading={true} />
      ) : revenueAgentsState.error ? (
        <ErrorRetry
          message={revenueAgentsState.message}
          onRetry={revenueAgentsState.onRetry}
        />
      ) : (
        <TopAgentsChart topRevenueAgents={revenueAgents} loading={false} />
      )}

      {categoryState.loading ? (
        <ProductMixChart revenueByCategory={[]} loading={true} />
      ) : categoryState.error ? (
        <ErrorRetry
          message={categoryState.message}
          onRetry={categoryState.onRetry}
        />
      ) : (
        <ProductMixChart revenueByCategory={categoryData} loading={false} />
      )}
    </div>
  );
}
